export default __webpack_public_path__ + "static/media/success.69bb6281.svg";